import {
  ProjectSelectField,
  type ProjectSelectOption,
} from '@/components/form/project-select-field'

type Props = {
  projects: ProjectSelectOption[]
  isAllowedToDeselect: boolean
}

export const Project = ({ projects, isAllowedToDeselect }: Props) => {
  return (
    <ProjectSelectField projects={projects} isOptional={isAllowedToDeselect} />
  )
}
